var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { UPDATE_CART, UPDATE_GLOBAL_STATE } from "../actions";
import get from "lodash/get";
var cartDefaultState = { cart_items: [] };
export var cartReducer = function (state, action) {
    if (state === void 0) { state = cartDefaultState; }
    var type = action.type, otherProps = __rest(action, ["type"]);
    switch (action.type) {
        case UPDATE_CART:
            return __assign(__assign({}, state), otherProps);
        case UPDATE_GLOBAL_STATE:
            return get(otherProps, "cartReducer", cartDefaultState);
        default:
            break;
    }
    return state;
};
